/**
 * Bridge to the native Android AutoPhotoUploadPlugin (android/app/src/main/java/solutions/
 * mangobusiness/personal/AutoPhotoUploadPlugin.java). No-ops entirely on web/PWA — 'auto' mode
 * behaves like 'prompt' there, same as before this existed. Call syncAutoPhotoWatching()
 * whenever the app comes to the foreground (see EventPhotoPrompt.tsx) so the native foreground
 * service only runs while a group actually has an open 'auto' event window.
 */
import { Capacitor, registerPlugin } from '@capacitor/core';
import { groupsApi, API_BASE_URL } from '../services/api';

interface AutoPhotoUploadPlugin {
  startWatching(options: { token: string; apiBaseUrl: string; windows: unknown[] }): Promise<{ watching: boolean }>;
  stopWatching(): Promise<{ watching: boolean }>;
  getStatus(): Promise<{ watching: boolean }>;
}

const AutoPhotoUpload = registerPlugin<AutoPhotoUploadPlugin>('AutoPhotoUpload');

export async function syncAutoPhotoWatching(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  const token = localStorage.getItem('mangoPersonalToken');
  if (!token) return;

  try {
    const res = await groupsApi.getActiveAutoWindows();
    const windows = res?.success && Array.isArray(res.data) ? res.data : [];

    if (windows.length === 0) {
      await AutoPhotoUpload.stopWatching();
      return;
    }

    await AutoPhotoUpload.startWatching({ token, apiBaseUrl: API_BASE_URL, windows });
  } catch (err) {
    console.warn('[AutoPhotoUpload] sync failed', err);
  }
}
